import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { createBrowserRouter } from 'react-router-dom';
import { SUPPORTED_LOCALES } from '~app/i18n';

export const useUrlLocale = (
  router: ReturnType<typeof createBrowserRouter>,
) => {
  const {
    i18n: { language: currentLanguage, changeLanguage },
  } = useTranslation();

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);

    const locale = SUPPORTED_LOCALES.find(
      locale => locale === searchParams.get('language'),
    );

    if (!locale) return;

    searchParams.delete('language');

    router.navigate({
      search: searchParams.toString(),
    });

    if (locale !== currentLanguage) {
      changeLanguage(locale);
    }
  }, [changeLanguage, currentLanguage, router]);
};
